/**
 * OIDC_TOGGLE_ACTIVE provided to global variable from .env
 */

import { isFeatureEnabled } from 'app-utils';

export const OIDC_TOGGLE_ACTIVE = isFeatureEnabled('OIDC');
